/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Link } from "react-router-dom";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";

import {
  MapStateToPropsSignup,
  SignUpProps,
  SignUpState,
} from "../../../shared/interfaces/components/signup.interface";
import * as actions from "../../../store/signup/actions";
import nexumLogo from "../../../assets/nexumLogo.png";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";

import Sidebar from "../../../shared/components/sidebar";
import Navbar from "../../../shared/components/navbar";
import { Product } from "../../../shared/interfaces/model/product.interface";
import "../../../../styles/singupPage/singupPopup.scss";
import { withNavigate } from "./navigateWrapper";
import "../../../../styles/singupPage/successPopup.scss";
import Button2 from "../../../shared/components/button/Button2";
import {
  Building2,
  CalendarIcon,
  CodeIcon,
  Compass,
  FileTextIcon,
  LocateFixedIcon,
  MailIcon,
  PhoneIcon,
  SaveIcon,
  TextCursor,
  UserIcon,
} from "lucide-react";

class SignUpUser extends Component<
  SignUpProps & { navigate: Function },
  SignUpState
> {
  constructor(props: SignUpProps & { navigate: Function }) {
    super(props);

    this.state = {
      organizationName: "",
      organizationEmail: "",
      productsSelected: [],
      tierSelected: { id: "", value: "" },
      numberEmployees: 0,
      subscriptionDuration: { id: "", value: "" },
      products: [],
      companyName: "",
      VAT: "",
      destinationCode: "",
      pec: "",
      isEmail: false,
      isFormValid: false,
      errors: {},
      showPopup: false,
      name: "",
      email: "",
      surname: "",
      dateOfBirth: "",
      city: "",
      province: "",
      fiscalCode: "",
      address: "",
      phoneNumber: "",
      isUser: true,
      showSuccessPopup: false,
    };
  }

  // componentDidUpdate(prevProps: SignUpProps) {
  //   if (this.props.isSignupOk) {
  //     // TODO => Una volta fatto login dove deve essere rediretto l'user?
  //     this.props.location("/private/tenantList");
  //     window.location.reload();
  //   }
  // }

  componentDidUpdate(prevProps: SignUpProps) {
    if (this.props.isSignupOk && !prevProps.isSignupOk) {
      // Quando la registrazione va a buon fine, mostra il popup di successo
      this.setState({ showSuccessPopup: true });
    } else if (
      !this.props.isSignupOk &&
      Object.keys(prevProps.signupError).length <= 0 &&
      this.props.signupError &&
      Object.keys(this.props.signupError).length > 0
    ) {
      this.setState({
        showPopup: true,
        errors: { error: this.props.signupError.response.data },
      });
    }
  }

  refName: React.RefObject<HTMLInputElement> = React.createRef();

  refUserEmail: React.RefObject<HTMLInputElement> = React.createRef();

  refSurname: React.RefObject<HTMLInputElement> = React.createRef();

  refDateOfBirth: React.RefObject<HTMLInputElement> = React.createRef();

  refCity: React.RefObject<HTMLInputElement> = React.createRef();

  refProvince: React.RefObject<HTMLInputElement> = React.createRef();

  refFiscalCode: React.RefObject<HTMLInputElement> = React.createRef();

  refAddress: React.RefObject<HTMLInputElement> = React.createRef();

  refPhoneNumber: React.RefObject<HTMLInputElement> = React.createRef();

  render() {
    const {
      name,
      email,
      surname,
      dateOfBirth,
      city,
      province,
      fiscalCode,
      address,
      phoneNumber,
      showSuccessPopup,
      showPopup,
      organizationName,
      organizationEmail,
      productsSelected,
      tierSelected,
      numberEmployees,
      subscriptionDuration,
      companyName,
      VAT,
      destinationCode,
      pec,
      isUser,
    } = this.state;

    // destructuring props
    const { postSignupRequest } = this.props;

    const closeSuccessPopup = () => {
      this.setState({ showSuccessPopup: false });
      this.props.navigate("/signin");
    };

    const validateEmail = (userEmail: string) => {
      const regex = /^[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/;
      return regex.test(userEmail);
    };

    const validateForm = () => {
      const errors: { [key: string]: string } = {};

      if (!this.state.name) {
        errors.name = "Name is required.";
      }

      if (this.state.email && !validateEmail(this.state.email)) {
        errors.userEmail = "Invalid email format.";
      }

      if (!this.state.email) {
        errors.userEmail = "Email is required.";
      }

      if (!this.state.surname) {
        errors.surname = "Surname is required.";
      }

      if (!this.state.dateOfBirth) {
        errors.dateOfBirth = "Date of birth is required.";
      }

      if (!this.state.city) {
        errors.city = "City is required.";
      }

      if (!this.state.province) {
        errors.province = "Province is required.";
      }

      if (!this.state.fiscalCode) {
        errors.fiscalCode = "Fiscal code is required.";
      }

      if (!this.state.address) {
        errors.address = "Address is required.";
      }

      if (!this.state.phoneNumber) {
        errors.phoneNumber = "Phone number is required.";
      }
      // Aggiorno gli errori nello stato
      this.setState({ errors });

      // Se l'oggetto errors è vuoto, il form è valido
      const isFormValid = Object.keys(errors).length === 0;

      // Aggiorno lo stato di isFormValid
      this.setState({ isFormValid });
      return errors;
    };

    const sendData = (data: object) => {
      const errors = validateForm(); // Restituisce un oggetto con errori
      // Se ci sono errori, mostriamo il popup
      if (Object.keys(errors).length > 0) {
        this.setState({ errors, showPopup: true });
      } else {
        // Nessun errore, nascondiamo il popup e inviamo i dati
        this.setState({ errors: {}, showPopup: false });
        postSignupRequest(data);
      }
    };

    const handleSaveClick = () => {
      const isFormValid = validateForm(); // Controlla se ci sono errori
      if (!isFormValid) {
        this.setState({ showPopup: true }); // Mostra il popup se ci sono errori
      } else {
        this.setState({ showPopup: false }); // Chiudi il popup se non ci sono errori
        sendData(this.state); // Invia i dati se il modulo è valido
      }
    };

    const nameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ name: data.target.value });
    };

    const surnameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ surname: data.target.value });
    };

    const emailChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ email: data.target.value });
    };

    // TODO => inserire selezione data invece di input, e modificare relativa logica
    const dateOfBirthChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ dateOfBirth: data.target.value });
    };

    // TODO => city va bene cosi scritto a mano? o bisogna implementare autosuggest/controlli?
    const cityChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ city: data.target.value });
    };

    const provinceChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ province: data.target.value });
    };

    const fiscalCodeChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ fiscalCode: data.target.value });
    };

    const addressChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ address: data.target.value });
    };

    const phoneNumberChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ phoneNumber: data.target.value });
    };

    return (
      <div>
        {/* Popup di successo */}
        {showSuccessPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <h2> Successfully registered!</h2>
              <p>
                An email has been sent to your email address. Please check and
                follow the instructions to complete your registration.
              </p>
              <button onClick={closeSuccessPopup}>Close</button>
            </div>
          </div>
        )}
        <div className="fixed top-0 bg-blue bg-opacity-10 h-screen w-screen -z-10" />
        <div className="w-full md:w-10/12 h-screen my-9 mb-5 ml-auto">
          <section data-test="signup-wrapper">
            <div className="p-2 md:p-10 w-full box-border flex flex-row flex-wrap justify-center">
              <div className="login-wrapper ">
                <article>
                  <div className="loginbox shadow-sm grow">
                    <div className="login-left bg-white bg-opacity-50">
                      <img
                        className="img-fluid"
                        src={nexumLogo}
                        alt="nexumLogo"
                      />
                    </div>
                    <div className="login-right">
                      <div className="login-right-wrap">
                        <h1>Register</h1>
                        <p className="account-subtitle"> Registration</p>
                        {this.state.showPopup && (
                          <div className="popup-overlay-e">
                            <div className="popup-e">
                              <h2>Form error</h2>
                              <ul>
                                {Object.keys(this.state.errors).map((key) => (
                                  <li key={key}>{this.state.errors[key]}</li>
                                ))}
                              </ul>
                              <button
                                onClick={() =>
                                  this.setState({ showPopup: false })
                                }
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        )}
                        <form>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="name"
                              name="name"
                              id="signup-name"
                              type="text"
                              label="Name:"
                              Icon={UserIcon}
                              value={name}
                              ref={this.refName}
                              title="Insert your name"
                              required
                              className="w-full p-3 border border-gray-200  min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                              onChangeHandler={nameChange}
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="cognome"
                              name="surname"
                              id="signup-surname"
                              type="text"
                              label="Surname:"
                              Icon={UserIcon}
                              value={surname}
                              ref={this.refSurname}
                              title="Insert your surname"
                              required
                              onChangeHandler={surnameChange}
                              className="w-full p-3 border border-gray-200 min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="email"
                              name="email"
                              id="signup-user-email"
                              type="email"
                              Icon={MailIcon}
                              label="Email:"
                              value={email}
                              ref={this.refUserEmail}
                              title="Insert your email"
                              className="w-full p-3 border border-gray-200 min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                              pattern={
                                /^[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/.source
                              }
                              required
                              onChangeHandler={emailChange}
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Data di nascita"
                              name="date-of-birth"
                              id="signup-date-of-birth"
                              type="text"
                              label="Date of Birth:"
                              Icon={CalendarIcon}
                              value={dateOfBirth}
                              ref={this.refDateOfBirth}
                              title="Insert your date of birth"
                              className="w-full p-3 border border-gray-200 min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                              onChangeHandler={dateOfBirthChange}
                              required
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Città"
                              name="city"
                              id="signup-city"
                              type="text"
                              label="City:"
                              value={city}
                              Icon={Building2}
                              ref={this.refCity}
                              onChangeHandler={cityChange}
                              title="Insert your city"
                              required
                              className="w-full p-3 border border-gray-200 min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Provincia"
                              name="province"
                              id="signup-province"
                              type="text"
                              Icon={Compass}
                              label="Province:"
                              value={province}
                              ref={this.refProvince}
                              title="Insert your province"
                              required
                              onChangeHandler={provinceChange}
                              className="w-full p-3 border border-gray-200 min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Codice Fiscale"
                              name="fiscal-code"
                              id="signup-fiscal-code"
                              type="text"
                              label="Fiscal Code:"
                              Icon={FileTextIcon}
                              value={fiscalCode}
                              ref={this.refFiscalCode}
                              title="Insert your fiscal code"
                              required
                              onChangeHandler={fiscalCodeChange}
                              className="w-full p-3 border border-gray-200  min-h-12 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Indirizzo"
                              name="address"
                              id="signup-address"
                              type="text"
                              label="Address:"
                              Icon={LocateFixedIcon}
                              value={address}
                              ref={this.refAddress}
                              title="Insert your address"
                              required
                              onChangeHandler={addressChange}
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Numero di telefono"
                              name="phone-number"
                              id="signup-phone-number"
                              type="text"
                              label="Phone Number:"
                              Icon={PhoneIcon}
                              value={phoneNumber}
                              ref={this.refPhoneNumber}
                              title="Insert your phone number"
                              required
                              onChangeHandler={phoneNumberChange}
                              className="w-full p-3 border min-h-12 border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>

                          <div className="form-group">
                            <Button2
                              title="Save"
                              icon={SaveIcon}
                              className="w-full mb-2 min-h-14"
                              onClick={() => {
                                handleSaveClick();
                              }}
                            />
                          </div>
                        </form>

                        <Link to="/signin">
                          <p
                            style={{
                              color: "#00336a",
                              textDecoration: "underline",
                            }}
                          >
                            Already have an account? Login!
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  postSignupRequest: (payload: object) => {
    dispatch(actions.postSignUpRequest(payload));
  },
});
// const mapStateToProps = (state: MapStateToPropsSignup) => ({
//   isSignupUserOk: state.signupReducer.isSignupOk,
// });

const mapStateToProps = (state: MapStateToPropsSignup) => ({
  isSignupOk: state.signupReducer.isSignupOk, // correzione qui
  signupError: state.signupReducer.signupError,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNavigate(SignUpUser));
